/**
 * Class chứa các function xử lý tác vụ focus trong 1 scope
 */
class FocusUtility {
  static focusableSelector = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /**
   * Tìm những element có thể focus được trong scope
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author ndvu - 20.01.2025
   */
  getFocusableElements(scope) {
    return Array.from(scope.querySelectorAll(FocusUtility.focusableSelector));
  }

  /**
   * Xử lý trap nút tab, không cho tab ra ngoài focusableElements
   * @param {Event} event 
   * @param {Array<Element>} focusableElements 
   */
  handleTab(event, focusableElements) {
    if (event.key === 'Tab') {
      const { activeElement } = document;
      const firstElement = focusableElements.value[0];
      const lastElement = focusableElements.value[focusableElements.value.length - 1];

      if (event.shiftKey) {
        // Shift + Tab
        if (activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        // Tab
        if (activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  };


}
export default new FocusUtility();
